import { useState, useEffect } from "react";

function useIsMobile() {
    const [isMobile, setIsMobile] = useState(null);

    useEffect(() => {
        const check = () => setIsMobile(window.innerWidth <= 768);
        check();
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, []);

    return isMobile;
}

export default useIsMobile;
